"use client";

// src/theme/palettes.ts
var sageGrey = {
  50: "#f4f7f4",
  100: "#e3ebe2",
  200: "#d4e0d3",
  300: "#bdcfbc",
  // The anchor color
  400: "#9fb89e",
  500: "#7a9a79",
  600: "#5f7d5e",
  700: "#4d654c",
  800: "#3f5140",
  900: "#354436",
  950: "#1a241a"
};
var deepForestPalette = {
  name: "deep-forest",
  displayName: "Deep Forest",
  description: "Professional, clean, and easy on the eyes",
  light: {
    background: {
      default: "#f4f2f6",
      // Warm lavender
      paper: "#ffffff",
      elevated: "#ebe7f0",
      // Deeper lavender
      gradient: "linear-gradient(135deg, #f4f2f6 0%, #ebe7f0 100%)"
    },
    primary: {
      50: "#f0fdf4",
      100: "#dcfce7",
      200: "#bbf7d0",
      300: "#86efac",
      400: "#4ade80",
      500: "#14532d",
      // Deep Green (main)
      600: "#166534",
      700: "#15803d",
      800: "#14532d",
      900: "#052e16",
      950: "#022c22",
      contrast: "#ffffff"
    },
    secondary: {
      50: "#fffbeb",
      100: "#fef3c7",
      200: "#fde68a",
      300: "#fcd34d",
      400: "#fbbf24",
      500: "#a16207",
      // Bronze (main)
      600: "#92400e",
      700: "#78350f",
      800: "#451a03",
      900: "#422006",
      950: "#27150a",
      contrast: "#ffffff"
    },
    text: {
      primary: "#052e16",
      // Ink Green
      secondary: "#4a4654",
      // Neutral charcoal w/ subtle violet
      disabled: "#9b9aa3",
      // Neutral gray
      hint: "#76757f"
      // Neutral gray
    },
    divider: "#d5d0de",
    // Lavender-gray
    success: {
      light: "#86efac",
      main: "#22c55e",
      dark: "#16a34a",
      contrast: "#ffffff"
    },
    warning: {
      light: "#fde68a",
      main: "#a16207",
      dark: "#78350f",
      contrast: "#ffffff"
    },
    error: {
      light: "#fecaca",
      main: "#dc2626",
      dark: "#991b1b",
      contrast: "#ffffff"
    },
    info: {
      light: "#bae6fd",
      main: "#0284c7",
      dark: "#075985",
      contrast: "#ffffff"
    }
  },
  dark: {
    background: {
      default: "#0f1712",
      // Deep Pine Black
      paper: "#1a2e1f",
      // Dark Forest
      elevated: "#243828",
      gradient: "linear-gradient(135deg, #0f1712 0%, #1a2e1f 100%)"
    },
    primary: {
      50: "#f0fdf4",
      100: "#dcfce7",
      200: "#bbf7d0",
      300: "#86efac",
      400: "#bdcfbc",
      // Sage becomes the accent
      500: "#bdcfbc",
      // Sage (main in dark)
      600: "#9fb89e",
      700: "#7a9a79",
      800: "#5f7d5e",
      900: "#4d654c",
      950: "#354436",
      contrast: "#052e16"
    },
    secondary: {
      50: "#fffbeb",
      100: "#fef3c7",
      200: "#fde68a",
      300: "#fcd34d",
      400: "#d97706",
      // Muted Gold
      500: "#d97706",
      // Muted Gold (main)
      600: "#b45309",
      700: "#92400e",
      800: "#78350f",
      900: "#451a03",
      950: "#27150a",
      contrast: "#052e16"
    },
    text: {
      primary: "#e3ebe2",
      // Pale Sage
      secondary: "#9fb89e",
      disabled: "#5f7d5e",
      hint: "#7a9a79"
    },
    divider: "#354436",
    success: {
      light: "#86efac",
      main: "#4ade80",
      dark: "#22c55e",
      contrast: "#052e16"
    },
    warning: {
      light: "#fde68a",
      main: "#d97706",
      dark: "#a16207",
      contrast: "#052e16"
    },
    error: {
      light: "#fecaca",
      main: "#f87171",
      dark: "#dc2626",
      contrast: "#052e16"
    },
    info: {
      light: "#bae6fd",
      main: "#38bdf8",
      dark: "#0284c7",
      contrast: "#052e16"
    }
  }
};
var earthClayPalette = {
  name: "earth-clay",
  displayName: "Earth & Clay",
  description: "Warm earth tones with sophisticated rust accents",
  light: {
    background: {
      default: "#f5ebe0",
      // Warm cream
      paper: "#ffffff",
      elevated: "#f5f5f4",
      // Warm white
      gradient: "linear-gradient(135deg, #f5ebe0 0%, #f5f5f4 100%)"
    },
    primary: {
      50: "#f6f7f5",
      100: "#e3e7e1",
      200: "#c8d1c5",
      300: "#a3b29f",
      400: "#7a9176",
      500: "#3f4d3b",
      // Olive Drab (main)
      600: "#344032",
      700: "#2c3529",
      800: "#252c23",
      900: "#1f251e",
      950: "#0f1310",
      contrast: "#ffffff"
    },
    secondary: {
      50: "#fef7ed",
      100: "#fdead7",
      200: "#f9d2ae",
      300: "#f5b37a",
      400: "#ef8844",
      500: "#9a3412",
      // Burnt Rust (main)
      600: "#7c2d12",
      700: "#6a2410",
      800: "#581c0c",
      900: "#431307",
      950: "#2a0a03",
      contrast: "#ffffff"
    },
    text: {
      primary: "#171717",
      // Near Black
      secondary: "#525252",
      disabled: "#a3a3a3",
      hint: "#737373"
    },
    divider: "#e5e5e5",
    success: {
      light: "#86efac",
      main: "#22c55e",
      dark: "#16a34a",
      contrast: "#ffffff"
    },
    warning: {
      light: "#fdba74",
      main: "#ea580c",
      dark: "#9a3412",
      contrast: "#ffffff"
    },
    error: {
      light: "#fecaca",
      main: "#dc2626",
      dark: "#991b1b",
      contrast: "#ffffff"
    },
    info: {
      light: "#bae6fd",
      main: "#0284c7",
      dark: "#075985",
      contrast: "#ffffff"
    }
  },
  dark: {
    background: {
      default: "#1c1917",
      // Warm Charcoal
      paper: "#292524",
      // Stone Grey
      elevated: "#3f3a36",
      gradient: "linear-gradient(135deg, #1c1917 0%, #292524 100%)"
    },
    primary: {
      50: "#f0fdf4",
      100: "#dcfce7",
      200: "#bbf7d0",
      300: "#86efac",
      // Mint Pop
      400: "#86efac",
      500: "#86efac",
      // Mint (main in dark)
      600: "#4ade80",
      700: "#22c55e",
      800: "#16a34a",
      900: "#14532d",
      950: "#052e16",
      contrast: "#1c1917"
    },
    secondary: {
      50: "#fff7ed",
      100: "#ffedd5",
      200: "#fed7aa",
      300: "#fdba74",
      // Soft Peach
      400: "#fdba74",
      500: "#fdba74",
      // Soft Peach (main)
      600: "#fb923c",
      700: "#ea580c",
      800: "#c2410c",
      900: "#9a3412",
      950: "#431407",
      contrast: "#1c1917"
    },
    text: {
      primary: "#e7e5e4",
      // Warm Grey
      secondary: "#a8a29e",
      disabled: "#78716c",
      hint: "#a8a29e"
    },
    divider: "#44403c",
    success: {
      light: "#86efac",
      main: "#4ade80",
      dark: "#22c55e",
      contrast: "#1c1917"
    },
    warning: {
      light: "#fdba74",
      main: "#fb923c",
      dark: "#ea580c",
      contrast: "#1c1917"
    },
    error: {
      light: "#fecaca",
      main: "#f87171",
      dark: "#dc2626",
      contrast: "#1c1917"
    },
    info: {
      light: "#bae6fd",
      main: "#38bdf8",
      dark: "#0284c7",
      contrast: "#1c1917"
    }
  }
};
var slateSagePalette = {
  name: "slate-sage",
  displayName: "Slate & Sage",
  description: "Modern software UI with organic sage accents",
  light: {
    background: {
      default: "#f0f4f8",
      // Cool blue-grey
      paper: "#ffffff",
      elevated: "#f1f5f9",
      // Ice White
      gradient: "linear-gradient(135deg, #f0f4f8 0%, #f1f5f9 100%)"
    },
    primary: {
      50: "#f8fafc",
      100: "#f1f5f9",
      200: "#e2e8f0",
      300: "#cbd5e1",
      400: "#94a3b8",
      500: "#334155",
      // Slate Blue-Grey (main)
      600: "#1e293b",
      700: "#0f172a",
      800: "#0c1322",
      900: "#080d19",
      950: "#030712",
      contrast: "#ffffff"
    },
    secondary: {
      50: "#f0fdfa",
      100: "#ccfbf1",
      200: "#99f6e4",
      300: "#5eead4",
      400: "#2dd4bf",
      500: "#0f766e",
      // Teal (main)
      600: "#0d6d66",
      700: "#115e59",
      800: "#134e4a",
      900: "#042f2e",
      950: "#021716",
      contrast: "#ffffff"
    },
    text: {
      primary: "#020617",
      // Black
      secondary: "#334155",
      disabled: "#94a3b8",
      hint: "#64748b"
    },
    divider: "#e2e8f0",
    success: {
      light: "#86efac",
      main: "#22c55e",
      dark: "#16a34a",
      contrast: "#ffffff"
    },
    warning: {
      light: "#fde68a",
      main: "#d97706",
      dark: "#92400e",
      contrast: "#ffffff"
    },
    error: {
      light: "#fecaca",
      main: "#dc2626",
      dark: "#991b1b",
      contrast: "#ffffff"
    },
    info: {
      light: "#bae6fd",
      main: "#0284c7",
      dark: "#075985",
      contrast: "#ffffff"
    }
  },
  dark: {
    background: {
      default: "#0f172a",
      // Midnight Slate
      paper: "#1e293b",
      // Slate Grey
      elevated: "#334155",
      gradient: "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)"
    },
    primary: {
      50: "#f4f7f4",
      100: "#e3ebe2",
      200: "#d4e0d3",
      300: "#bdcfbc",
      // Sage becomes accent
      400: "#bdcfbc",
      500: "#bdcfbc",
      // Sage (main in dark)
      600: "#9fb89e",
      700: "#7a9a79",
      800: "#5f7d5e",
      900: "#4d654c",
      950: "#354436",
      contrast: "#0f172a"
    },
    secondary: {
      50: "#f0fdfa",
      100: "#ccfbf1",
      200: "#99f6e4",
      300: "#5eead4",
      400: "#2dd4bf",
      // Cyan/Teal
      500: "#2dd4bf",
      // Cyan/Teal (main)
      600: "#14b8a6",
      700: "#0d9488",
      800: "#0f766e",
      900: "#115e59",
      950: "#042f2e",
      contrast: "#0f172a"
    },
    text: {
      primary: "#f8fafc",
      // White
      secondary: "#cbd5e1",
      disabled: "#64748b",
      hint: "#94a3b8"
    },
    divider: "#334155",
    success: {
      light: "#86efac",
      main: "#4ade80",
      dark: "#22c55e",
      contrast: "#0f172a"
    },
    warning: {
      light: "#fde68a",
      main: "#fbbf24",
      dark: "#d97706",
      contrast: "#0f172a"
    },
    error: {
      light: "#fecaca",
      main: "#f87171",
      dark: "#dc2626",
      contrast: "#0f172a"
    },
    info: {
      light: "#bae6fd",
      main: "#38bdf8",
      dark: "#0284c7",
      contrast: "#0f172a"
    }
  }
};
var themePalettes = {
  "deep-forest": deepForestPalette,
  "earth-clay": earthClayPalette,
  "slate-sage": slateSagePalette
};
var themeNames = ["deep-forest", "earth-clay", "slate-sage"];
var defaultTheme = "deep-forest";
var neutral = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#e5e5e5",
  300: "#d4d4d4",
  400: "#a3a3a3",
  500: "#737373",
  600: "#525252",
  700: "#404040",
  800: "#262626",
  900: "#171717",
  950: "#0a0a0a"
};

// src/theme/colors.ts
var currentTheme = defaultTheme;
var currentMode = "light";
function setCurrentTheme(theme2) {
  currentTheme = theme2;
}
function setCurrentMode(mode) {
  currentMode = mode;
}
function getCurrentTheme() {
  return currentTheme;
}
function getCurrentMode() {
  return currentMode;
}
function getCurrentColors() {
  return themePalettes[currentTheme][currentMode];
}
function getColorsForTheme(theme2, mode) {
  return themePalettes[theme2][mode];
}
var defaultPalette = themePalettes["deep-forest"].light;
var colors = {
  // Primary palette
  primary: defaultPalette.primary,
  // Secondary palette
  secondary: defaultPalette.secondary,
  // We no longer have a separate accent - use secondary or primary based on context
  // Keeping for backward compatibility, mapped to secondary
  accent: defaultPalette.secondary,
  // Neutral grays (shared across all themes)
  neutral,
  // Sage Grey (the anchor color)
  sage: sageGrey,
  // Semantic colors
  success: defaultPalette.success,
  warning: defaultPalette.warning,
  error: defaultPalette.error,
  info: defaultPalette.info,
  // Surface colors
  background: defaultPalette.background,
  text: defaultPalette.text,
  divider: defaultPalette.divider,
  shadow: "rgba(0, 0, 0, 0.1)"
};
function generateCSSVariables(theme2, mode) {
  const palette = themePalettes[theme2][mode];
  return {
    // Background
    "--color-background-default": palette.background.default,
    "--color-background-paper": palette.background.paper,
    "--color-background-elevated": palette.background.elevated,
    // Primary
    "--color-primary-50": palette.primary[50],
    "--color-primary-100": palette.primary[100],
    "--color-primary-200": palette.primary[200],
    "--color-primary-300": palette.primary[300],
    "--color-primary-400": palette.primary[400],
    "--color-primary-500": palette.primary[500],
    "--color-primary-600": palette.primary[600],
    "--color-primary-700": palette.primary[700],
    "--color-primary-800": palette.primary[800],
    "--color-primary-900": palette.primary[900],
    "--color-primary-950": palette.primary[950],
    "--color-primary": palette.primary[500],
    // Secondary
    "--color-secondary-50": palette.secondary[50],
    "--color-secondary-100": palette.secondary[100],
    "--color-secondary-200": palette.secondary[200],
    "--color-secondary-300": palette.secondary[300],
    "--color-secondary-400": palette.secondary[400],
    "--color-secondary-500": palette.secondary[500],
    "--color-secondary-600": palette.secondary[600],
    "--color-secondary-700": palette.secondary[700],
    "--color-secondary-800": palette.secondary[800],
    "--color-secondary-900": palette.secondary[900],
    "--color-secondary-950": palette.secondary[950],
    "--color-secondary": palette.secondary[500],
    // Text
    "--color-text-primary": palette.text.primary,
    "--color-text-secondary": palette.text.secondary,
    "--color-text-disabled": palette.text.disabled,
    "--color-text-hint": palette.text.hint,
    // Semantic
    "--color-success-light": palette.success.light,
    "--color-success": palette.success.main,
    "--color-success-dark": palette.success.dark,
    "--color-warning-light": palette.warning.light,
    "--color-warning": palette.warning.main,
    "--color-warning-dark": palette.warning.dark,
    "--color-error-light": palette.error.light,
    "--color-error": palette.error.main,
    "--color-error-dark": palette.error.dark,
    "--color-info-light": palette.info.light,
    "--color-info": palette.info.main,
    "--color-info-dark": palette.info.dark,
    // Divider
    "--color-divider": palette.divider,
    // Sage (constant across themes)
    "--color-sage-300": sageGrey[300],
    "--color-sage-500": sageGrey[500]
  };
}
function getCSSVariablesString(theme2, mode) {
  const vars = generateCSSVariables(theme2, mode);
  return Object.entries(vars).map(([key, value]) => `${key}: ${value};`).join("\n");
}

// src/theme/spacing.ts
var spacing = {
  0: 0,
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  7: 28,
  8: 32,
  9: 36,
  10: 40,
  11: 44,
  12: 48,
  14: 56,
  16: 64,
  20: 80,
  24: 96,
  28: 112,
  32: 128,
  36: 144,
  40: 160,
  44: 176,
  48: 192,
  52: 208,
  56: 224,
  60: 240,
  64: 256,
  72: 288,
  80: 320,
  96: 384
};

// src/theme/typography.ts
var typography = {
  fontFamily: {
    sans: ["Inter", "system-ui", "sans-serif"],
    serif: ["Georgia", "serif"],
    mono: ["Fira Code", "monospace"]
  },
  fontSize: {
    xs: { size: 12, lineHeight: 16 },
    sm: { size: 14, lineHeight: 20 },
    base: { size: 16, lineHeight: 24 },
    lg: { size: 18, lineHeight: 28 },
    xl: { size: 20, lineHeight: 28 },
    "2xl": { size: 24, lineHeight: 32 },
    "3xl": { size: 30, lineHeight: 36 },
    "4xl": { size: 36, lineHeight: 40 },
    "5xl": { size: 48, lineHeight: 48 },
    "6xl": { size: 60, lineHeight: 60 },
    "7xl": { size: 72, lineHeight: 72 },
    "8xl": { size: 96, lineHeight: 96 },
    "9xl": { size: 128, lineHeight: 128 }
  },
  fontWeight: {
    thin: "100",
    extralight: "200",
    light: "300",
    normal: "400",
    medium: "500",
    semibold: "600",
    bold: "700",
    extrabold: "800",
    black: "900"
  },
  letterSpacing: {
    tighter: -0.05,
    tight: -0.025,
    normal: 0,
    wide: 0.025,
    wider: 0.05,
    widest: 0.1
  }
};

// src/theme/shadows.ts
var shadows = {
  none: "none",
  sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
  base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)",
  md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)",
  lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)",
  xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)",
  "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
  inner: "inset 0 2px 4px 0 rgba(0, 0, 0, 0.05)"
};
var elevation = {
  0: {
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0,
    shadowRadius: 0,
    elevation: 0
  },
  1: {
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.18,
    shadowRadius: 1,
    elevation: 1
  },
  2: {
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.2,
    shadowRadius: 1.41,
    elevation: 2
  },
  3: {
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.22,
    shadowRadius: 2.22,
    elevation: 3
  },
  4: {
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4
  },
  5: {
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5
  }
};

// src/theme/borders.ts
var borderRadius = {
  none: 0,
  sm: 2,
  base: 4,
  md: 6,
  lg: 8,
  xl: 12,
  "2xl": 16,
  "3xl": 24,
  full: 9999
};
var borderWidth = {
  0: 0,
  DEFAULT: 1,
  2: 2,
  4: 4,
  8: 8
};

// src/hooks/useThemeColors.ts
import { useMemo } from "react";
function useThemeColors(themeName, mode) {
  return useMemo(() => {
    if (themeName && mode) {
      return getColorsForTheme(themeName, mode);
    }
    const currentTheme2 = getCurrentTheme();
    const currentMode2 = getCurrentMode();
    return getColorsForTheme(currentTheme2, currentMode2);
  }, [themeName, mode]);
}
function getColor(colorGroup, shade) {
  const group = colors[colorGroup];
  if (typeof group === "object" && shade !== void 0) {
    return group[shade];
  }
  return group;
}
function getThemeColor(themeName, mode, colorGroup, shade) {
  const palette = themePalettes[themeName][mode];
  if (colorGroup === "text" || colorGroup === "background") {
    const group2 = palette[colorGroup];
    if (shade && shade in group2) {
      return group2[shade];
    }
    return group2;
  }
  if (colorGroup === "success" || colorGroup === "warning" || colorGroup === "error" || colorGroup === "info") {
    const group2 = palette[colorGroup];
    if (shade === "light") return group2.light;
    if (shade === "dark") return group2.dark;
    return group2.main;
  }
  const group = palette[colorGroup];
  if (typeof shade === "number" && shade in group) {
    return group[shade];
  }
  return group[500];
}
function useAvailableThemes() {
  return useMemo(() => {
    return Object.entries(themePalettes).map(([name, palette]) => ({
      name,
      displayName: palette.displayName,
      description: palette.description
    }));
  }, []);
}

// src/components/AuthLayout.tsx
import { jsx } from "react/jsx-runtime";
var gradientVariants = {
  default: "from-neutral-500 to-neutral-600",
  green: "from-primary-500 to-primary-600",
  blue: "from-accent-500 to-accent-600",
  purple: "from-secondary-500 to-secondary-600"
};
var maxWidthVariants = {
  sm: "max-w-sm",
  md: "max-w-md",
  lg: "max-w-lg",
  xl: "max-w-xl",
  "2xl": "max-w-2xl",
  "3xl": "max-w-3xl",
  "4xl": "max-w-4xl",
  "5xl": "max-w-5xl",
  "6xl": "max-w-6xl",
  full: "max-w-full"
};
function AuthLayout({
  children,
  variant = "default",
  maxWidth = "md",
  className = ""
}) {
  const gradientClass = gradientVariants[variant];
  const maxWidthClass = maxWidthVariants[maxWidth];
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: `min-h-screen flex items-center justify-center bg-gradient-to-br ${gradientClass} py-4 ${className}`,
      children: /* @__PURE__ */ jsx("div", { className: `w-full ${maxWidthClass} px-4`, children })
    }
  );
}

// src/components/PageContainer.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var containerVariants = {
  standard: "max-w-4xl",
  wide: "max-w-6xl",
  full: "max-w-7xl"
};
var paddingVariants = {
  section: "px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20",
  nav: "px-4 sm:px-6 lg:px-8"
};
function PageContainer({
  variant = "standard",
  padding = "section",
  children,
  className = "",
  as: Component = "div"
}) {
  const maxWidthClass = containerVariants[variant];
  const paddingClass = paddingVariants[padding];
  return /* @__PURE__ */ jsx2(Component, { className: `${maxWidthClass} mx-auto ${paddingClass} ${className}`.trim(), children });
}

// src/components/AuthCard.tsx
import { jsx as jsx3, jsxs } from "react/jsx-runtime";
function AuthCard({
  children,
  title,
  subtitle,
  className = ""
}) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: `bg-background-paper dark:bg-neutral-800 rounded-lg shadow-lg p-6 md:p-8 ${className}`,
      children: [
        (title || subtitle) && /* @__PURE__ */ jsxs("div", { className: "text-center mb-6", children: [
          title && /* @__PURE__ */ jsx3("h1", { className: "text-3xl font-bold text-text-primary mb-2", children: title }),
          subtitle && /* @__PURE__ */ jsx3("p", { className: "text-text-secondary", children: subtitle })
        ] }),
        children
      ]
    }
  );
}

// src/components/ThemeProvider.tsx
import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { ThemeProvider as NextThemesProvider, useTheme as useNextTheme } from "next-themes";
import { jsx as jsx4 } from "react/jsx-runtime";
var ThemeContext = createContext(null);
function useAppTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useAppTheme must be used within a ThemeProvider");
  }
  return context;
}
var THEME_STORAGE_KEY = "pmp-theme-name";
var MODE_STORAGE_KEY = "pmp-theme-mode";
function ThemeProvider({
  children,
  defaultThemeName = defaultTheme,
  defaultMode = "light",
  ...nextThemeProps
}) {
  const [themeName, setThemeNameState] = useState(defaultThemeName);
  const [mode, setModeState] = useState(defaultMode);
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    const savedTheme = localStorage.getItem(THEME_STORAGE_KEY);
    const savedMode = localStorage.getItem(MODE_STORAGE_KEY);
    if (savedTheme && themeNames.includes(savedTheme)) {
      setThemeNameState(savedTheme);
      setCurrentTheme(savedTheme);
    }
    if (savedMode && (savedMode === "light" || savedMode === "dark")) {
      setModeState(savedMode);
      setCurrentMode(savedMode);
    }
    setMounted(true);
  }, []);
  useEffect(() => {
    if (mounted && typeof document !== "undefined") {
      document.documentElement.setAttribute("data-theme", themeName);
      document.documentElement.setAttribute("data-mode", mode);
    }
  }, [themeName, mode, mounted]);
  const setThemeName = useCallback((name) => {
    setThemeNameState(name);
    setCurrentTheme(name);
    localStorage.setItem(THEME_STORAGE_KEY, name);
  }, []);
  const setMode = useCallback((newMode) => {
    setModeState(newMode);
    setCurrentMode(newMode);
    localStorage.setItem(MODE_STORAGE_KEY, newMode);
  }, []);
  const toggleMode = useCallback(() => {
    setMode(mode === "light" ? "dark" : "light");
  }, [mode, setMode]);
  const availableThemes = themeNames.map((name) => ({
    name,
    displayName: themePalettes[name].displayName,
    description: themePalettes[name].description
  }));
  const contextValue = {
    themeName,
    mode,
    setThemeName,
    setMode,
    toggleMode,
    availableThemes
  };
  if (!mounted) {
    return /* @__PURE__ */ jsx4(ThemeContext.Provider, { value: contextValue, children: /* @__PURE__ */ jsx4(NextThemesProvider, { attribute: "class", defaultTheme: "light", ...nextThemeProps, children }) });
  }
  return /* @__PURE__ */ jsx4(ThemeContext.Provider, { value: contextValue, children: /* @__PURE__ */ jsx4(
    NextThemesProvider,
    {
      attribute: "class",
      defaultTheme: mode,
      forcedTheme: mode,
      ...nextThemeProps,
      children
    }
  ) });
}
function ThemeSynchronizer() {
  const { mode, setMode } = useAppTheme();
  const { theme: nextTheme, setTheme: setNextTheme } = useNextTheme();
  useEffect(() => {
    if (nextTheme !== mode) {
      setNextTheme(mode);
    }
  }, [mode, nextTheme, setNextTheme]);
  useEffect(() => {
    if (nextTheme && nextTheme !== mode && (nextTheme === "light" || nextTheme === "dark")) {
      setMode(nextTheme);
    }
  }, [nextTheme, mode, setMode]);
  return null;
}

// src/components/ThemeToggle.tsx
import { useEffect as useEffect2, useState as useState2 } from "react";
import { useTheme } from "next-themes";
import { Moon, Sun } from "lucide-react";
import { jsx as jsx5, jsxs as jsxs2 } from "react/jsx-runtime";
function ThemeToggle() {
  const [mounted, setMounted] = useState2(false);
  const { theme: theme2, setTheme } = useTheme();
  useEffect2(() => {
    setMounted(true);
  }, []);
  if (!mounted) {
    return /* @__PURE__ */ jsx5("div", { className: "w-10 h-10 bg-neutral-100 dark:bg-neutral-800 rounded-lg animate-pulse" });
  }
  return /* @__PURE__ */ jsxs2(
    "button",
    {
      onClick: () => setTheme(theme2 === "dark" ? "light" : "dark"),
      className: "relative w-10 h-10 flex items-center justify-center rounded-lg bg-neutral-100 hover:bg-neutral-200 dark:bg-neutral-800 dark:hover:bg-neutral-700 transition-colors",
      "aria-label": `Switch to ${theme2 === "dark" ? "light" : "dark"} mode`,
      children: [
        /* @__PURE__ */ jsx5(Sun, { className: "w-5 h-5 text-neutral-700 dark:text-neutral-200 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0 absolute" }),
        /* @__PURE__ */ jsx5(Moon, { className: "w-5 h-5 text-neutral-700 dark:text-neutral-200 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100 absolute" })
      ]
    }
  );
}

// src/components/ThemeSelector.tsx
import { useState as useState3 } from "react";
import { Moon as Moon2, Sun as Sun2, Check, Palette } from "lucide-react";
import { Fragment, jsx as jsx6, jsxs as jsxs3 } from "react/jsx-runtime";
function ThemeColorPreview({ themeName }) {
  const palette = themePalettes[themeName].light;
  return /* @__PURE__ */ jsxs3("div", { className: "flex gap-1", children: [
    /* @__PURE__ */ jsx6(
      "div",
      {
        className: "w-4 h-4 rounded-full border border-neutral-300",
        style: { backgroundColor: palette.background.default },
        title: "Background"
      }
    ),
    /* @__PURE__ */ jsx6(
      "div",
      {
        className: "w-4 h-4 rounded-full border border-neutral-300",
        style: { backgroundColor: palette.primary[500] },
        title: "Primary"
      }
    ),
    /* @__PURE__ */ jsx6(
      "div",
      {
        className: "w-4 h-4 rounded-full border border-neutral-300",
        style: { backgroundColor: palette.secondary[500] },
        title: "Secondary"
      }
    )
  ] });
}
function ThemeSelector() {
  const { themeName, mode, setThemeName, toggleMode, availableThemes } = useAppTheme();
  const [isOpen, setIsOpen] = useState3(false);
  return /* @__PURE__ */ jsxs3("div", { className: "relative", children: [
    /* @__PURE__ */ jsxs3(
      "button",
      {
        onClick: () => setIsOpen(!isOpen),
        className: "flex items-center gap-2 px-3 py-2 rounded-lg bg-background-paper hover:bg-background-elevated border border-divider transition-colors",
        "aria-label": "Open theme selector",
        children: [
          /* @__PURE__ */ jsx6(Palette, { className: "w-4 h-4 text-text-secondary" }),
          /* @__PURE__ */ jsx6("span", { className: "text-sm text-text-primary hidden sm:inline", children: themePalettes[themeName].displayName }),
          /* @__PURE__ */ jsx6("div", { className: "w-px h-4 bg-divider hidden sm:block" }),
          mode === "light" ? /* @__PURE__ */ jsx6(Sun2, { className: "w-4 h-4 text-secondary" }) : /* @__PURE__ */ jsx6(Moon2, { className: "w-4 h-4 text-secondary" })
        ]
      }
    ),
    isOpen && /* @__PURE__ */ jsxs3(Fragment, { children: [
      /* @__PURE__ */ jsx6("div", { className: "fixed inset-0 z-40", onClick: () => setIsOpen(false) }),
      /* @__PURE__ */ jsxs3("div", { className: "absolute right-0 top-full mt-2 w-72 rounded-xl bg-background-paper border border-divider shadow-lg z-50 overflow-hidden", children: [
        /* @__PURE__ */ jsxs3("div", { className: "p-2", children: [
          /* @__PURE__ */ jsx6("div", { className: "text-xs font-medium text-text-secondary uppercase tracking-wide px-2 py-1", children: "Theme" }),
          availableThemes.map((theme2) => /* @__PURE__ */ jsxs3(
            "button",
            {
              onClick: () => {
                setThemeName(theme2.name);
              },
              className: `w-full flex items-center gap-3 px-2 py-2 rounded-lg transition-colors ${themeName === theme2.name ? "bg-primary/10" : "hover:bg-background-elevated"}`,
              children: [
                /* @__PURE__ */ jsx6(ThemeColorPreview, { themeName: theme2.name }),
                /* @__PURE__ */ jsxs3("div", { className: "flex-1 text-left", children: [
                  /* @__PURE__ */ jsx6("div", { className: "text-sm font-medium text-text-primary", children: theme2.displayName }),
                  /* @__PURE__ */ jsx6("div", { className: "text-xs text-text-secondary", children: theme2.description })
                ] }),
                themeName === theme2.name && /* @__PURE__ */ jsx6(Check, { className: "w-4 h-4 text-primary" })
              ]
            },
            theme2.name
          ))
        ] }),
        /* @__PURE__ */ jsx6("div", { className: "h-px bg-divider" }),
        /* @__PURE__ */ jsxs3("div", { className: "p-2", children: [
          /* @__PURE__ */ jsx6("div", { className: "text-xs font-medium text-text-secondary uppercase tracking-wide px-2 py-1", children: "Mode" }),
          /* @__PURE__ */ jsxs3("div", { className: "flex gap-2 px-2 py-1", children: [
            /* @__PURE__ */ jsxs3(
              "button",
              {
                onClick: () => {
                  if (mode !== "light") toggleMode();
                },
                className: `flex-1 flex items-center justify-center gap-2 px-3 py-2 rounded-lg transition-colors ${mode === "light" ? "bg-primary text-white" : "bg-background-elevated text-text-secondary hover:text-text-primary"}`,
                children: [
                  /* @__PURE__ */ jsx6(Sun2, { className: "w-4 h-4" }),
                  /* @__PURE__ */ jsx6("span", { className: "text-sm", children: "Light" })
                ]
              }
            ),
            /* @__PURE__ */ jsxs3(
              "button",
              {
                onClick: () => {
                  if (mode !== "dark") toggleMode();
                },
                className: `flex-1 flex items-center justify-center gap-2 px-3 py-2 rounded-lg transition-colors ${mode === "dark" ? "bg-primary text-white" : "bg-background-elevated text-text-secondary hover:text-text-primary"}`,
                children: [
                  /* @__PURE__ */ jsx6(Moon2, { className: "w-4 h-4" }),
                  /* @__PURE__ */ jsx6("span", { className: "text-sm", children: "Dark" })
                ]
              }
            )
          ] })
        ] })
      ] })
    ] })
  ] });
}
function ThemeToggleCompact() {
  const { mode, toggleMode, themeName } = useAppTheme();
  const palette = themePalettes[themeName].light;
  return /* @__PURE__ */ jsxs3(
    "button",
    {
      onClick: toggleMode,
      className: "relative w-10 h-10 flex items-center justify-center rounded-lg bg-background-elevated hover:bg-neutral-200 dark:hover:bg-neutral-700 transition-colors",
      "aria-label": `Switch to ${mode === "dark" ? "light" : "dark"} mode`,
      children: [
        /* @__PURE__ */ jsx6(
          "div",
          {
            className: "absolute top-1 right-1 w-2 h-2 rounded-full",
            style: { backgroundColor: palette.primary[500] }
          }
        ),
        /* @__PURE__ */ jsx6(Sun2, { className: "w-5 h-5 text-text-secondary rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0 absolute" }),
        /* @__PURE__ */ jsx6(Moon2, { className: "w-5 h-5 text-text-secondary rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100 absolute" })
      ]
    }
  );
}
function ThemeCards() {
  const { themeName, setThemeName, availableThemes } = useAppTheme();
  return /* @__PURE__ */ jsx6("div", { className: "grid grid-cols-1 sm:grid-cols-3 gap-4", children: availableThemes.map((theme2) => {
    const palette = themePalettes[theme2.name];
    const isSelected = themeName === theme2.name;
    return /* @__PURE__ */ jsxs3(
      "button",
      {
        onClick: () => setThemeName(theme2.name),
        className: `relative p-4 rounded-xl border-2 transition-all ${isSelected ? "border-primary bg-primary/5" : "border-divider hover:border-primary/50"}`,
        children: [
          /* @__PURE__ */ jsxs3("div", { className: "flex h-8 rounded-lg overflow-hidden mb-3", children: [
            /* @__PURE__ */ jsx6(
              "div",
              {
                className: "flex-1",
                style: { backgroundColor: palette.light.background.default }
              }
            ),
            /* @__PURE__ */ jsx6("div", { className: "flex-1", style: { backgroundColor: palette.light.primary[500] } }),
            /* @__PURE__ */ jsx6("div", { className: "flex-1", style: { backgroundColor: palette.light.secondary[500] } })
          ] }),
          /* @__PURE__ */ jsxs3("div", { className: "text-left", children: [
            /* @__PURE__ */ jsx6("div", { className: "font-medium text-text-primary", children: theme2.displayName }),
            /* @__PURE__ */ jsx6("div", { className: "text-sm text-text-secondary", children: theme2.description })
          ] }),
          isSelected && /* @__PURE__ */ jsx6("div", { className: "absolute top-2 right-2", children: /* @__PURE__ */ jsx6(Check, { className: "w-5 h-5 text-primary" }) })
        ]
      },
      theme2.name
    );
  }) });
}

// src/components/web/Alert.tsx
import React3 from "react";

// src/utils/cn.ts
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// src/components/web/Alert.tsx
import { jsx as jsx7, jsxs as jsxs4 } from "react/jsx-runtime";
var Alert = React3.forwardRef(
  ({
    className,
    severity = "info",
    variant = "standard",
    icon,
    action,
    onClose,
    onX,
    children,
    ...props
  }, ref) => {
    const handleClose = onX ?? onClose;
    const baseClasses = "flex items-start gap-3 rounded-lg p-4";
    const severityClasses = {
      standard: {
        error: "bg-error-light/10 text-error-dark border-l-4 border-error",
        warning: "bg-warning-light/10 text-warning-dark border-l-4 border-warning",
        info: "bg-info-light/10 text-info-dark border-l-4 border-info",
        success: "bg-success-light/10 text-success-dark border-l-4 border-success"
      },
      filled: {
        error: "bg-error text-white",
        warning: "bg-warning text-white",
        info: "bg-info text-white",
        success: "bg-success text-white"
      },
      outlined: {
        error: "border border-error text-error bg-transparent",
        warning: "border border-warning text-warning bg-transparent",
        info: "border border-info text-info bg-transparent",
        success: "border border-success text-success bg-transparent"
      }
    };
    const defaultIcons = {
      error: /* @__PURE__ */ jsx7("svg", { className: "h-5 w-5 flex-shrink-0", fill: "currentColor", viewBox: "0 0 20 20", children: /* @__PURE__ */ jsx7(
        "path",
        {
          fillRule: "evenodd",
          d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
          clipRule: "evenodd"
        }
      ) }),
      warning: /* @__PURE__ */ jsx7("svg", { className: "h-5 w-5 flex-shrink-0", fill: "currentColor", viewBox: "0 0 20 20", children: /* @__PURE__ */ jsx7(
        "path",
        {
          fillRule: "evenodd",
          d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
          clipRule: "evenodd"
        }
      ) }),
      info: /* @__PURE__ */ jsx7("svg", { className: "h-5 w-5 flex-shrink-0", fill: "currentColor", viewBox: "0 0 20 20", children: /* @__PURE__ */ jsx7(
        "path",
        {
          fillRule: "evenodd",
          d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
          clipRule: "evenodd"
        }
      ) }),
      success: /* @__PURE__ */ jsx7("svg", { className: "h-5 w-5 flex-shrink-0", fill: "currentColor", viewBox: "0 0 20 20", children: /* @__PURE__ */ jsx7(
        "path",
        {
          fillRule: "evenodd",
          d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
          clipRule: "evenodd"
        }
      ) })
    };
    return /* @__PURE__ */ jsxs4(
      "div",
      {
        ref,
        role: "alert",
        className: cn(baseClasses, severityClasses[variant][severity], className),
        ...props,
        children: [
          icon !== null && (icon || defaultIcons[severity]),
          /* @__PURE__ */ jsx7("div", { className: "flex-1 text-sm", children }),
          action && /* @__PURE__ */ jsx7("div", { className: "flex-shrink-0", children: action }),
          handleClose && /* @__PURE__ */ jsx7(
            "button",
            {
              type: "button",
              onClick: handleClose,
              className: "flex-shrink-0 rounded p-1 hover:bg-black/10 focus:outline-none focus:ring-2 focus:ring-offset-2",
              children: /* @__PURE__ */ jsx7("svg", { className: "h-4 w-4", fill: "currentColor", viewBox: "0 0 20 20", children: /* @__PURE__ */ jsx7(
                "path",
                {
                  fillRule: "evenodd",
                  d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                  clipRule: "evenodd"
                }
              ) })
            }
          )
        ]
      }
    );
  }
);
Alert.displayName = "Alert";

// src/components/web/Avatar.tsx
import React4 from "react";
import { jsx as jsx8 } from "react/jsx-runtime";
var Avatar = React4.forwardRef(
  ({ className, src, alt = "", size = "medium", variant = "circular", children, ...props }, ref) => {
    const sizeClasses = {
      small: "h-8 w-8 text-sm",
      medium: "h-10 w-10 text-base",
      large: "h-14 w-14 text-lg"
    };
    const variantClasses = {
      circular: "rounded-full",
      rounded: "rounded-lg",
      square: "rounded-none"
    };
    const sizeClass = typeof size === "number" ? "" : sizeClasses[size];
    const sizeStyle = typeof size === "number" ? { height: size, width: size } : void 0;
    const baseClasses = cn(
      "relative inline-flex items-center justify-center overflow-hidden bg-neutral-200 text-neutral-600 font-medium",
      sizeClass,
      variantClasses[variant],
      className
    );
    if (src) {
      return /* @__PURE__ */ jsx8("div", { ref, className: baseClasses, style: sizeStyle, ...props, children: /* @__PURE__ */ jsx8("img", { src, alt, className: "h-full w-full object-cover" }) });
    }
    return /* @__PURE__ */ jsx8("div", { ref, className: baseClasses, style: sizeStyle, ...props, children: children || /* @__PURE__ */ jsx8("svg", { className: "h-1/2 w-1/2", fill: "currentColor", viewBox: "0 0 20 20", children: /* @__PURE__ */ jsx8(
      "path",
      {
        fillRule: "evenodd",
        d: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z",
        clipRule: "evenodd"
      }
    ) }) });
  }
);
Avatar.displayName = "Avatar";

// src/components/web/Button.tsx
import React5 from "react";
import { jsx as jsx9, jsxs as jsxs5 } from "react/jsx-runtime";
var Button = React5.forwardRef(
  ({
    className,
    variant = "contained",
    color = "primary",
    size = "medium",
    fullWidth = false,
    startIcon,
    endIcon,
    disabled = false,
    children,
    ...props
  }, ref) => {
    const baseClasses = "inline-flex items-center justify-center font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50";
    const variantClasses = {
      contained: {
        primary: "bg-primary-500 text-white hover:bg-primary-600 focus-visible:ring-primary-500",
        secondary: "bg-secondary-500 text-white hover:bg-secondary-600 focus-visible:ring-secondary-500",
        error: "bg-error text-white hover:bg-error-dark focus-visible:ring-error",
        warning: "bg-warning text-white hover:bg-warning-dark focus-visible:ring-warning",
        info: "bg-info text-white hover:bg-info-dark focus-visible:ring-info",
        success: "bg-success text-white hover:bg-success-dark focus-visible:ring-success"
      },
      outlined: {
        primary: "border border-primary-500 text-primary-500 hover:bg-primary-50 focus-visible:ring-primary-500",
        secondary: "border border-secondary-500 text-secondary-500 hover:bg-secondary-50 focus-visible:ring-secondary-500",
        error: "border border-error text-error hover:bg-error-light/10 focus-visible:ring-error",
        warning: "border border-warning text-warning hover:bg-warning-light/10 focus-visible:ring-warning",
        info: "border border-info text-info hover:bg-info-light/10 focus-visible:ring-info",
        success: "border border-success text-success hover:bg-success-light/10 focus-visible:ring-success"
      },
      text: {
        primary: "text-primary-500 hover:bg-primary-50 focus-visible:ring-primary-500",
        secondary: "text-secondary-500 hover:bg-secondary-50 focus-visible:ring-secondary-500",
        error: "text-error hover:bg-error-light/10 focus-visible:ring-error",
        warning: "text-warning hover:bg-warning-light/10 focus-visible:ring-warning",
        info: "text-info hover:bg-info-light/10 focus-visible:ring-info",
        success: "text-success hover:bg-success-light/10 focus-visible:ring-success"
      },
      // Support legacy 'primary' variant as 'contained'
      primary: {
        primary: "bg-primary-500 text-white hover:bg-primary-600 focus-visible:ring-primary-500",
        secondary: "bg-secondary-500 text-white hover:bg-secondary-600 focus-visible:ring-secondary-500",
        error: "bg-error text-white hover:bg-error-dark focus-visible:ring-error",
        warning: "bg-warning text-white hover:bg-warning-dark focus-visible:ring-warning",
        info: "bg-info text-white hover:bg-info-dark focus-visible:ring-info",
        success: "bg-success text-white hover:bg-success-dark focus-visible:ring-success"
      }
    };
    const sizeClasses = {
      small: "h-8 px-3 text-sm rounded-md gap-1",
      medium: "h-10 px-4 py-2 rounded-md gap-2",
      large: "h-12 px-6 py-3 text-lg rounded-lg gap-2",
      // Support legacy 'lg' size
      lg: "h-12 px-6 py-3 text-lg rounded-lg gap-2"
    };
    const widthClasses = fullWidth ? "w-full" : "";
    const validVariant = variant && variant in variantClasses ? variant : "contained";
    const variantStyle = variantClasses[validVariant];
    const validColor = color && color in variantStyle ? color : "primary";
    const colorStyle = variantStyle[validColor];
    const validSize = size && size in sizeClasses ? size : "medium";
    const sizeStyle = sizeClasses[validSize];
    return /* @__PURE__ */ jsxs5(
      "button",
      {
        ref,
        className: cn(baseClasses, colorStyle, sizeStyle, widthClasses, className),
        disabled,
        ...props,
        children: [
          startIcon && /* @__PURE__ */ jsx9("span", { className: "flex items-center justify-center", children: startIcon }),
          children,
          endIcon && /* @__PURE__ */ jsx9("span", { className: "flex items-center justify-center", children: endIcon })
        ]
      }
    );
  }
);
Button.displayName = "Button";

// src/components/web/Card.tsx
import React6 from "react";
import { jsx as jsx10 } from "react/jsx-runtime";
var Card = React6.forwardRef(
  ({ className, elevation: elevation2 = 1, variant = "elevation", ...props }, ref) => {
    const elevationClasses = {
      0: "shadow-none",
      1: "shadow-sm",
      2: "shadow-md",
      3: "shadow-lg",
      4: "shadow-xl",
      5: "shadow-2xl"
    };
    const baseClasses = "bg-background-paper rounded-lg";
    const variantClasses = variant === "outlined" ? "border border-divider" : elevationClasses[elevation2];
    return /* @__PURE__ */ jsx10("div", { ref, className: cn(baseClasses, variantClasses, className), ...props });
  }
);
Card.displayName = "Card";
var CardContent = React6.forwardRef(
  ({ className, ...props }, ref) => {
    return /* @__PURE__ */ jsx10("div", { ref, className: cn("p-6", className), ...props });
  }
);
CardContent.displayName = "CardContent";
var CardHeader = React6.forwardRef(
  ({ className, ...props }, ref) => {
    return /* @__PURE__ */ jsx10("div", { ref, className: cn("flex flex-col space-y-1.5 p-6 pb-4", className), ...props });
  }
);
CardHeader.displayName = "CardHeader";
var CardTitle = React6.forwardRef(
  ({ className, ...props }, ref) => {
    return /* @__PURE__ */ jsx10(
      "h3",
      {
        ref,
        className: cn(
          "text-lg font-semibold leading-none tracking-tight text-text-primary",
          className
        ),
        ...props
      }
    );
  }
);
CardTitle.displayName = "CardTitle";
var CardDescription = React6.forwardRef(
  ({ className, ...props }, ref) => {
    return /* @__PURE__ */ jsx10("p", { ref, className: cn("text-sm text-text-secondary", className), ...props });
  }
);
CardDescription.displayName = "CardDescription";
var CardFooter = React6.forwardRef(
  ({ className, ...props }, ref) => {
    return /* @__PURE__ */ jsx10("div", { ref, className: cn("flex items-center p-6 pt-0", className), ...props });
  }
);
CardFooter.displayName = "CardFooter";

// src/components/web/Checkbox.tsx
import React7 from "react";
import { jsx as jsx11, jsxs as jsxs6 } from "react/jsx-runtime";
var Checkbox = React7.forwardRef(
  ({ label, checked, onChange, disabled = false, error = false, className, id, ...props }, ref) => {
    const generatedId = React7.useId();
    const inputId = id ?? generatedId;
    const handleChange = (event) => {
      onChange?.(event, event.target.checked);
    };
    return /* @__PURE__ */ jsxs6(
      "label",
      {
        htmlFor: inputId,
        className: cn(
          "inline-flex items-center gap-2 select-none",
          disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer",
          className
        ),
        children: [
          /* @__PURE__ */ jsxs6("span", { className: "relative inline-flex items-center justify-center w-5 h-5", children: [
            /* @__PURE__ */ jsx11(
              "input",
              {
                id: inputId,
                ref,
                type: "checkbox",
                checked,
                onChange: handleChange,
                disabled,
                className: "peer sr-only",
                "aria-invalid": error || void 0,
                ...props
              }
            ),
            /* @__PURE__ */ jsx11(
              "span",
              {
                className: cn(
                  "absolute inset-0 rounded border-2 transition-colors",
                  "peer-focus-visible:ring-2 peer-focus-visible:ring-primary-500 peer-focus-visible:ring-offset-1",
                  checked ? "border-primary-600 bg-primary-600" : "border-divider bg-background-paper",
                  checked && disabled && "border-primary-400 bg-primary-400",
                  !checked && disabled && "border-neutral-300 bg-neutral-100",
                  error && !checked && "border-error",
                  error && checked && "border-error bg-error"
                )
              }
            ),
            checked && /* @__PURE__ */ jsx11(
              "svg",
              {
                className: cn("relative w-3 h-3 text-white pointer-events-none"),
                viewBox: "0 0 12 10",
                fill: "none",
                "aria-hidden": "true",
                children: /* @__PURE__ */ jsx11(
                  "path",
                  {
                    d: "M1 5.5L4 8.5L11 1.5",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  }
                )
              }
            )
          ] }),
          label && /* @__PURE__ */ jsx11(
            "span",
            {
              className: cn(
                "text-sm text-text-primary",
                disabled && "text-text-disabled",
                error && "text-error"
              ),
              children: label
            }
          )
        ]
      }
    );
  }
);
Checkbox.displayName = "Checkbox";

// src/components/web/Chip.tsx
import React8 from "react";
import { jsx as jsx12, jsxs as jsxs7 } from "react/jsx-runtime";
var Chip = React8.forwardRef(
  ({
    className,
    label,
    variant = "filled",
    color = "default",
    size = "medium",
    icon,
    deleteIcon,
    onDelete,
    disabled = false,
    clickable = false,
    children,
    onClick,
    ...props
  }, ref) => {
    const baseClasses = cn(
      "inline-flex items-center justify-center font-medium transition-colors",
      clickable && !disabled && "cursor-pointer",
      disabled && "opacity-50 cursor-not-allowed"
    );
    const sizeClasses = {
      small: "h-6 text-xs px-2 gap-1 rounded-full",
      medium: "h-8 text-sm px-3 gap-1.5 rounded-full"
    };
    const colorClasses = {
      filled: {
        default: "bg-neutral-200 text-neutral-800 hover:bg-neutral-300",
        primary: "bg-primary-500 text-white hover:bg-primary-600",
        secondary: "bg-secondary-500 text-white hover:bg-secondary-600",
        error: "bg-error text-white hover:bg-error-dark",
        warning: "bg-warning text-white hover:bg-warning-dark",
        info: "bg-info text-white hover:bg-info-dark",
        success: "bg-success text-white hover:bg-success-dark"
      },
      outlined: {
        default: "border border-neutral-300 text-neutral-800 hover:bg-neutral-50",
        primary: "border border-primary-500 text-primary-500 hover:bg-primary-50",
        secondary: "border border-secondary-500 text-secondary-500 hover:bg-secondary-50",
        error: "border border-error text-error hover:bg-error-light/10",
        warning: "border border-warning text-warning hover:bg-warning-light/10",
        info: "border border-info text-info hover:bg-info-light/10",
        success: "border border-success text-success hover:bg-success-light/10"
      }
    };
    const handleClick = (e) => {
      if (disabled) return;
      onClick?.(e);
    };
    const handleDelete = (e) => {
      e.stopPropagation();
      if (disabled) return;
      onDelete?.();
    };
    return /* @__PURE__ */ jsxs7(
      "div",
      {
        ref,
        className: cn(baseClasses, sizeClasses[size], colorClasses[variant][color], className),
        onClick: handleClick,
        role: clickable ? "button" : void 0,
        tabIndex: clickable && !disabled ? 0 : void 0,
        ...props,
        children: [
          icon && /* @__PURE__ */ jsx12("span", { className: "flex items-center", children: icon }),
          /* @__PURE__ */ jsx12("span", { children: label || children }),
          onDelete && /* @__PURE__ */ jsx12(
            "button",
            {
              type: "button",
              onClick: handleDelete,
              disabled,
              className: "ml-1 flex items-center justify-center rounded-full p-0.5 hover:bg-black/10 focus:outline-none",
              children: deleteIcon || /* @__PURE__ */ jsx12("svg", { className: "h-3.5 w-3.5", fill: "currentColor", viewBox: "0 0 20 20", children: /* @__PURE__ */ jsx12(
                "path",
                {
                  fillRule: "evenodd",
                  d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                  clipRule: "evenodd"
                }
              ) })
            }
          )
        ]
      }
    );
  }
);
Chip.displayName = "Chip";

// src/components/web/Divider.tsx
import React9 from "react";
import { jsx as jsx13, jsxs as jsxs8 } from "react/jsx-runtime";
var Divider = React9.forwardRef(
  ({
    className,
    orientation = "horizontal",
    variant = "fullWidth",
    textAlign = "center",
    children,
    ...props
  }, ref) => {
    const baseClasses = "border-divider";
    const orientationClasses = {
      horizontal: "w-full border-t",
      vertical: "h-full border-l self-stretch"
    };
    const variantClasses = {
      fullWidth: "",
      inset: orientation === "horizontal" ? "ml-16" : "mt-4",
      middle: orientation === "horizontal" ? "mx-4" : "my-4"
    };
    if (children) {
      const textAlignClasses = {
        left: "justify-start",
        center: "justify-center",
        right: "justify-end"
      };
      return /* @__PURE__ */ jsxs8(
        "div",
        {
          className: cn("flex items-center w-full", textAlignClasses[textAlign], className),
          role: "separator",
          children: [
            /* @__PURE__ */ jsx13(
              "div",
              {
                className: cn("flex-grow border-t border-divider", textAlign !== "left" && "mr-4")
              }
            ),
            /* @__PURE__ */ jsx13("span", { className: "text-sm text-text-secondary px-2", children }),
            /* @__PURE__ */ jsx13(
              "div",
              {
                className: cn("flex-grow border-t border-divider", textAlign !== "right" && "ml-4")
              }
            )
          ]
        }
      );
    }
    return /* @__PURE__ */ jsx13(
      "hr",
      {
        ref,
        className: cn(
          baseClasses,
          orientationClasses[orientation],
          variantClasses[variant],
          className
        ),
        ...props
      }
    );
  }
);
Divider.displayName = "Divider";

// src/components/web/IconButton.tsx
import React10 from "react";
import { jsx as jsx14 } from "react/jsx-runtime";
var IconButton = React10.forwardRef(
  ({
    className,
    size = "medium",
    color = "default",
    edge = false,
    disabled = false,
    children,
    ...props
  }, ref) => {
    const baseClasses = "inline-flex items-center justify-center rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50";
    const sizeClasses = {
      small: "h-8 w-8 p-1",
      medium: "h-10 w-10 p-2",
      large: "h-12 w-12 p-2.5"
    };
    const colorClasses = {
      default: "text-text-secondary hover:bg-neutral-100 focus-visible:ring-neutral-400",
      primary: "text-primary-500 hover:bg-primary-50 focus-visible:ring-primary-500",
      secondary: "text-secondary-500 hover:bg-secondary-50 focus-visible:ring-secondary-500",
      error: "text-error hover:bg-error-light/10 focus-visible:ring-error",
      inherit: "text-inherit hover:bg-black/5 focus-visible:ring-current"
    };
    const edgeClasses = {
      start: "-ml-3",
      end: "-mr-3",
      false: ""
    };
    return /* @__PURE__ */ jsx14(
      "button",
      {
        ref,
        className: cn(
          baseClasses,
          sizeClasses[size],
          colorClasses[color],
          edgeClasses[edge],
          className
        ),
        disabled,
        ...props,
        children
      }
    );
  }
);
IconButton.displayName = "IconButton";

// src/components/web/Input.tsx
import React11 from "react";
import { jsx as jsx15, jsxs as jsxs9 } from "react/jsx-runtime";
var Input = React11.forwardRef(
  ({
    className,
    type = "text",
    label,
    error = false,
    helperText,
    fullWidth = false,
    variant = "outlined",
    size,
    inputSize,
    startAdornment,
    endAdornment,
    disabled = false,
    ...props
  }, ref) => {
    const effectiveSize = size ?? inputSize ?? "medium";
    const inputId = React11.useId();
    const containerClasses = fullWidth ? "w-full" : "";
    const sizeClasses = {
      small: "h-8 px-3 text-sm",
      medium: "h-10 px-3 text-sm"
    };
    const variantClasses = {
      outlined: cn(
        "border border-divider rounded-md bg-background-paper",
        "focus:border-primary-500 focus:ring-1 focus:ring-primary-500",
        error && "border-error focus:border-error focus:ring-error",
        disabled && "bg-neutral-50 text-text-disabled"
      ),
      filled: cn(
        "border-0 border-b-2 border-divider rounded-t-md bg-neutral-50",
        "focus:border-primary-500 focus:ring-0",
        error && "border-error focus:border-error",
        disabled && "bg-neutral-100 text-text-disabled"
      ),
      standard: cn(
        "border-0 border-b border-divider rounded-none bg-transparent",
        "focus:border-primary-500 focus:ring-0",
        error && "border-error focus:border-error",
        disabled && "text-text-disabled"
      )
    };
    const baseInputClasses = cn(
      "flex w-full transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium",
      "placeholder:text-text-hint focus-visible:outline-none disabled:cursor-not-allowed",
      sizeClasses[effectiveSize],
      variantClasses[variant]
    );
    return /* @__PURE__ */ jsxs9("div", { className: cn("flex flex-col gap-1", containerClasses), children: [
      label && /* @__PURE__ */ jsx15(
        "label",
        {
          htmlFor: inputId,
          className: cn(
            "text-sm font-medium text-text-primary",
            error && "text-error",
            disabled && "text-text-disabled"
          ),
          children: label
        }
      ),
      /* @__PURE__ */ jsxs9("div", { className: "relative", children: [
        startAdornment && /* @__PURE__ */ jsx15("div", { className: "absolute left-3 top-1/2 -translate-y-1/2 text-text-secondary", children: startAdornment }),
        /* @__PURE__ */ jsx15(
          "input",
          {
            id: inputId,
            type,
            className: cn(
              baseInputClasses,
              startAdornment && "pl-10",
              endAdornment && "pr-10",
              className
            ),
            ref,
            disabled,
            ...props
          }
        ),
        endAdornment && /* @__PURE__ */ jsx15("div", { className: "absolute right-3 top-1/2 -translate-y-1/2 text-text-secondary", children: endAdornment })
      ] }),
      helperText && /* @__PURE__ */ jsx15("p", { className: cn("text-xs text-text-secondary", error && "text-error"), children: helperText })
    ] });
  }
);
Input.displayName = "Input";
var TextField = Input;

// src/components/web/Modal.tsx
import * as React12 from "react";
import { jsx as jsx16, jsxs as jsxs10 } from "react/jsx-runtime";
var Modal = ({
  open,
  onClose,
  children,
  title,
  className,
  overlayClassName,
  maxWidth = "sm",
  fullWidth = false,
  fullScreen = false,
  closeOnOverlayClick,
  closeOnEscape,
  disableBackdropClick,
  disableEscapeKeyDown
}) => {
  const effectiveCloseOnOverlay = closeOnOverlayClick ?? !disableBackdropClick ?? true;
  const effectiveCloseOnEscape = closeOnEscape ?? !disableEscapeKeyDown ?? true;
  const handleEscape = React12.useCallback(
    (e) => {
      if (e.key === "Escape" && effectiveCloseOnEscape) {
        onClose?.();
      }
    },
    [onClose, effectiveCloseOnEscape]
  );
  React12.useEffect(() => {
    if (open) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [open, handleEscape]);
  if (!open) return null;
  const maxWidthClasses = maxWidth ? {
    xs: "max-w-xs",
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-xl",
    full: "max-w-full"
  }[maxWidth] : "";
  const widthClasses = fullWidth ? "w-full" : "";
  const handleOverlayClick = (event) => {
    if (effectiveCloseOnOverlay && event.target === event.currentTarget) {
      onClose?.();
    }
  };
  return /* @__PURE__ */ jsxs10(
    "div",
    {
      className: cn("fixed inset-0 z-50 flex items-center justify-center", overlayClassName),
      onClick: handleOverlayClick,
      children: [
        /* @__PURE__ */ jsx16("div", { className: "absolute inset-0 bg-black/50 transition-opacity", "aria-hidden": "true" }),
        /* @__PURE__ */ jsxs10(
          "div",
          {
            className: cn(
              "relative z-10 bg-background-paper rounded-lg shadow-xl max-h-[90vh] overflow-auto m-4",
              fullScreen ? "w-full h-full max-w-none max-h-none m-0 rounded-none" : "",
              !fullScreen && maxWidthClasses,
              !fullScreen && widthClasses,
              className
            ),
            role: "dialog",
            "aria-modal": "true",
            children: [
              title && /* @__PURE__ */ jsxs10("div", { className: "px-6 py-4 border-b border-divider flex items-center justify-between", children: [
                /* @__PURE__ */ jsx16("h2", { className: "text-lg font-semibold text-text-primary", children: title }),
                onClose && /* @__PURE__ */ jsx16(
                  "button",
                  {
                    type: "button",
                    onClick: onClose,
                    className: "text-text-secondary hover:text-text-primary transition-colors",
                    "aria-label": "Close modal",
                    children: /* @__PURE__ */ jsx16("svg", { className: "w-5 h-5", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx16(
                      "path",
                      {
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: 2,
                        d: "M6 18L18 6M6 6l12 12"
                      }
                    ) })
                  }
                )
              ] }),
              children
            ]
          }
        )
      ]
    }
  );
};
var Dialog = Modal;
var DialogTitle = React12.forwardRef(
  ({ className, children, ...props }, ref) => /* @__PURE__ */ jsx16(
    "h2",
    {
      ref,
      className: cn("text-lg font-semibold text-text-primary px-6 pt-6 pb-2", className),
      ...props,
      children
    }
  )
);
DialogTitle.displayName = "DialogTitle";
var DialogContent = React12.forwardRef(
  ({ className, dividers = false, children, ...props }, ref) => /* @__PURE__ */ jsx16(
    "div",
    {
      ref,
      className: cn(
        "px-6 py-4 text-text-secondary",
        dividers && "border-y border-divider",
        className
      ),
      ...props,
      children
    }
  )
);
DialogContent.displayName = "DialogContent";
var DialogActions = React12.forwardRef(
  ({ className, children, ...props }, ref) => /* @__PURE__ */ jsx16(
    "div",
    {
      ref,
      className: cn("flex items-center justify-end gap-2 px-6 pb-6 pt-2", className),
      ...props,
      children
    }
  )
);
DialogActions.displayName = "DialogActions";

// src/components/web/Select.tsx
import React13 from "react";
import { jsx as jsx17, jsxs as jsxs11 } from "react/jsx-runtime";
var FormControl = React13.forwardRef(
  ({ className, fullWidth = false, error = false, disabled = false, children, ...props }, ref) => {
    return /* @__PURE__ */ jsx17(
      "div",
      {
        ref,
        className: cn(
          "flex flex-col gap-1",
          fullWidth && "w-full",
          disabled && "opacity-50",
          className
        ),
        ...props,
        children
      }
    );
  }
);
FormControl.displayName = "FormControl";
var InputLabel = React13.forwardRef(
  ({ className, required = false, error = false, disabled = false, children, ...props }, ref) => {
    return /* @__PURE__ */ jsxs11(
      "label",
      {
        ref,
        className: cn(
          "text-sm font-medium text-text-primary",
          error && "text-error",
          disabled && "text-text-disabled",
          className
        ),
        ...props,
        children: [
          children,
          required && /* @__PURE__ */ jsx17("span", { className: "text-error ml-1", children: "*" })
        ]
      }
    );
  }
);
InputLabel.displayName = "InputLabel";
var Select = React13.forwardRef(
  ({
    className,
    label,
    error = false,
    helperText,
    fullWidth = false,
    variant = "outlined",
    disabled = false,
    children,
    ...props
  }, ref) => {
    const selectId = React13.useId();
    const variantClasses = {
      outlined: cn(
        "border border-divider rounded-md bg-background-paper",
        "focus:border-primary-500 focus:ring-1 focus:ring-primary-500",
        error && "border-error focus:border-error focus:ring-error"
      ),
      filled: cn(
        "border-0 border-b-2 border-divider rounded-t-md bg-neutral-50",
        "focus:border-primary-500 focus:ring-0",
        error && "border-error focus:border-error"
      ),
      standard: cn(
        "border-0 border-b border-divider rounded-none bg-transparent",
        "focus:border-primary-500 focus:ring-0",
        error && "border-error focus:border-error"
      )
    };
    return /* @__PURE__ */ jsxs11("div", { className: cn("flex flex-col gap-1", fullWidth && "w-full"), children: [
      label && /* @__PURE__ */ jsx17(
        "label",
        {
          htmlFor: selectId,
          className: cn(
            "text-sm font-medium text-text-primary",
            error && "text-error",
            disabled && "text-text-disabled"
          ),
          children: label
        }
      ),
      /* @__PURE__ */ jsx17(
        "select",
        {
          id: selectId,
          ref,
          disabled,
          className: cn(
            "h-10 px-3 text-sm transition-colors appearance-none cursor-pointer",
            "focus-visible:outline-none disabled:cursor-not-allowed disabled:bg-neutral-50",
            variantClasses[variant],
            className
          ),
          ...props,
          children
        }
      ),
      helperText && /* @__PURE__ */ jsx17("p", { className: cn("text-xs text-text-secondary", error && "text-error"), children: helperText })
    ] });
  }
);
Select.displayName = "Select";
var MenuItem = React13.forwardRef(
  ({ className, children, ...props }, ref) => {
    return /* @__PURE__ */ jsx17("option", { ref, className: cn("py-2 px-3", className), ...props, children });
  }
);
MenuItem.displayName = "MenuItem";

// src/components/web/Spinner.tsx
import React14 from "react";
import { jsx as jsx18, jsxs as jsxs12 } from "react/jsx-runtime";
var Spinner = React14.forwardRef(
  ({ className, size = "medium", color = "primary", ...props }, ref) => {
    const sizeClasses = {
      small: "h-4 w-4",
      medium: "h-8 w-8",
      large: "h-12 w-12"
    };
    const colorClasses = {
      primary: "text-primary-500",
      secondary: "text-secondary-500",
      inherit: "text-current"
    };
    const sizeClass = typeof size === "number" ? "" : sizeClasses[size];
    const sizeStyle = typeof size === "number" ? { height: size, width: size } : void 0;
    return /* @__PURE__ */ jsx18(
      "div",
      {
        ref,
        className: cn("animate-spin", sizeClass, colorClasses[color], className),
        style: sizeStyle,
        role: "status",
        "aria-label": "Loading",
        ...props,
        children: /* @__PURE__ */ jsxs12(
          "svg",
          {
            className: "h-full w-full",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            children: [
              /* @__PURE__ */ jsx18(
                "circle",
                {
                  className: "opacity-25",
                  cx: "12",
                  cy: "12",
                  r: "10",
                  stroke: "currentColor",
                  strokeWidth: "4"
                }
              ),
              /* @__PURE__ */ jsx18(
                "path",
                {
                  className: "opacity-75",
                  fill: "currentColor",
                  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                }
              )
            ]
          }
        )
      }
    );
  }
);
Spinner.displayName = "Spinner";
var CircularProgress = Spinner;

// src/components/web/Textarea.tsx
import React15 from "react";
import { jsx as jsx19, jsxs as jsxs13 } from "react/jsx-runtime";
var Textarea = React15.forwardRef(
  ({
    className,
    label,
    error = false,
    helperText,
    fullWidth = false,
    variant = "outlined",
    rows = 3,
    maxLength,
    disabled = false,
    ...props
  }, ref) => {
    const textareaId = React15.useId();
    const containerClasses = fullWidth ? "w-full" : "";
    const variantClasses = {
      outlined: cn(
        "border border-divider rounded-md bg-background-paper",
        "focus:border-primary-500 focus:ring-1 focus:ring-primary-500",
        error && "border-error focus:border-error focus:ring-error",
        disabled && "bg-neutral-50 text-text-disabled"
      ),
      filled: cn(
        "border-0 border-b-2 border-divider rounded-t-md bg-neutral-50",
        "focus:border-primary-500 focus:ring-0",
        error && "border-error focus:border-error",
        disabled && "bg-neutral-100 text-text-disabled"
      ),
      standard: cn(
        "border-0 border-b border-divider rounded-none bg-transparent",
        "focus:border-primary-500 focus:ring-0",
        error && "border-error focus:border-error",
        disabled && "text-text-disabled"
      )
    };
    const baseTextareaClasses = cn(
      "flex w-full px-3 py-2 text-sm transition-colors",
      "placeholder:text-text-hint focus-visible:outline-none disabled:cursor-not-allowed",
      "resize-vertical rounded-md",
      variantClasses[variant]
    );
    return /* @__PURE__ */ jsxs13("div", { className: cn("flex flex-col gap-1", containerClasses), children: [
      label && /* @__PURE__ */ jsx19(
        "label",
        {
          htmlFor: textareaId,
          className: cn(
            "text-sm font-medium text-text-primary",
            error && "text-error",
            disabled && "text-text-disabled"
          ),
          children: label
        }
      ),
      /* @__PURE__ */ jsx19(
        "textarea",
        {
          id: textareaId,
          className: cn(baseTextareaClasses, className),
          ref,
          rows,
          maxLength,
          disabled,
          "aria-invalid": error || void 0,
          "aria-describedby": helperText ? `${textareaId}-helper` : void 0,
          ...props
        }
      ),
      helperText && /* @__PURE__ */ jsx19(
        "p",
        {
          id: `${textareaId}-helper`,
          className: cn("text-xs text-text-secondary", error && "text-error"),
          children: helperText
        }
      )
    ] });
  }
);
Textarea.displayName = "Textarea";

// src/components/web/Tabs.tsx
import * as React16 from "react";
import { jsx as jsx20, jsxs as jsxs14 } from "react/jsx-runtime";
var TabsContext = React16.createContext(null);
var Tabs = React16.forwardRef(
  ({
    className,
    value: controlledValue,
    defaultValue,
    onChange,
    variant = "standard",
    children,
    ...props
  }, ref) => {
    const [internalValue, setInternalValue] = React16.useState(defaultValue ?? 0);
    const value = controlledValue ?? internalValue;
    const handleChange = (newValue) => {
      setInternalValue(newValue);
      onChange?.(newValue);
    };
    return /* @__PURE__ */ jsx20(TabsContext.Provider, { value: { value, onChange: handleChange }, children: /* @__PURE__ */ jsx20(
      "div",
      {
        ref,
        className: cn(
          "flex border-b border-divider",
          variant === "fullWidth" && "w-full",
          className
        ),
        role: "tablist",
        ...props,
        children
      }
    ) });
  }
);
Tabs.displayName = "Tabs";
var Tab = React16.forwardRef(
  ({ className, value, label, icon, iconPosition = "start", disabled = false, children, ...props }, ref) => {
    const context = React16.useContext(TabsContext);
    if (!context) {
      throw new Error("Tab must be used within Tabs");
    }
    const { value: selectedValue, onChange } = context;
    const isSelected = selectedValue === value;
    const iconPositionClasses = {
      start: "flex-row",
      end: "flex-row-reverse",
      top: "flex-col",
      bottom: "flex-col-reverse"
    };
    return /* @__PURE__ */ jsxs14(
      "button",
      {
        ref,
        role: "tab",
        "aria-selected": isSelected,
        tabIndex: isSelected ? 0 : -1,
        disabled,
        className: cn(
          "inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium transition-colors",
          "border-b-2 -mb-px",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2",
          isSelected ? "text-primary-500 border-primary-500" : "text-text-secondary border-transparent hover:text-text-primary hover:border-neutral-300",
          disabled && "opacity-50 cursor-not-allowed",
          iconPositionClasses[iconPosition],
          className
        ),
        onClick: () => onChange(value),
        ...props,
        children: [
          icon,
          label || children
        ]
      }
    );
  }
);
Tab.displayName = "Tab";
var TabPanel = React16.forwardRef(
  ({ className, value, index, children, ...props }, ref) => {
    const isActive = value === index;
    if (!isActive) return null;
    return /* @__PURE__ */ jsx20("div", { ref, role: "tabpanel", tabIndex: 0, className: cn("py-4", className), ...props, children });
  }
);
TabPanel.displayName = "TabPanel";

// src/components/web/ToggleButton.tsx
import * as React17 from "react";
import { jsx as jsx21 } from "react/jsx-runtime";
var ToggleButtonGroupContext = React17.createContext(null);
var ToggleButtonGroup = React17.forwardRef(
  ({
    className,
    value = null,
    onChange,
    exclusive = false,
    size = "medium",
    color = "standard",
    orientation = "horizontal",
    fullWidth = false,
    disabled = false,
    children,
    ...props
  }, ref) => {
    const handleChange = (buttonValue) => {
      if (disabled) return;
      if (exclusive) {
        onChange?.(value === buttonValue ? null : buttonValue);
      } else {
        const currentValue = value || [];
        const newValue = currentValue.includes(buttonValue) ? currentValue.filter((v) => v !== buttonValue) : [...currentValue, buttonValue];
        onChange?.(newValue.length > 0 ? newValue : null);
      }
    };
    return /* @__PURE__ */ jsx21(ToggleButtonGroupContext.Provider, { value: { value, onChange: handleChange, exclusive }, children: /* @__PURE__ */ jsx21(
      "div",
      {
        ref,
        role: "group",
        className: cn(
          "inline-flex",
          orientation === "vertical" ? "flex-col" : "flex-row",
          fullWidth && "w-full",
          className
        ),
        ...props,
        children
      }
    ) });
  }
);
ToggleButtonGroup.displayName = "ToggleButtonGroup";
var ToggleButton = React17.forwardRef(
  ({
    className,
    value,
    selected: controlledSelected,
    size = "medium",
    color = "standard",
    disabled = false,
    children,
    onClick,
    ...props
  }, ref) => {
    const context = React17.useContext(ToggleButtonGroupContext);
    let isSelected = controlledSelected;
    if (context) {
      const { value: groupValue, exclusive } = context;
      if (exclusive) {
        isSelected = groupValue === value;
      } else {
        isSelected = Array.isArray(groupValue) && groupValue.includes(value);
      }
    }
    const sizeClasses = {
      small: "h-8 px-2 text-sm",
      medium: "h-10 px-3 text-sm",
      large: "h-12 px-4 text-base"
    };
    const colorClasses = {
      standard: isSelected ? "bg-neutral-200 text-text-primary" : "bg-transparent text-text-secondary hover:bg-neutral-100",
      primary: isSelected ? "bg-primary-500 text-white" : "bg-transparent text-text-secondary hover:bg-primary-50",
      secondary: isSelected ? "bg-secondary-500 text-white" : "bg-transparent text-text-secondary hover:bg-secondary-50"
    };
    const handleClick = (e) => {
      if (context) {
        context.onChange(value);
      }
      onClick?.(e);
    };
    return /* @__PURE__ */ jsx21(
      "button",
      {
        ref,
        type: "button",
        role: "button",
        "aria-pressed": isSelected,
        disabled,
        className: cn(
          "inline-flex items-center justify-center border border-divider transition-colors",
          "first:rounded-l-md last:rounded-r-md",
          "-ml-px first:ml-0",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:z-10",
          "disabled:opacity-50 disabled:cursor-not-allowed",
          sizeClasses[size],
          colorClasses[color],
          className
        ),
        onClick: handleClick,
        ...props,
        children
      }
    );
  }
);
ToggleButton.displayName = "ToggleButton";

// src/components/web/Pagination.tsx
import { jsx as jsx22, jsxs as jsxs15 } from "react/jsx-runtime";
function getVisiblePages(page, totalPages, maxVisiblePages) {
  if (totalPages <= maxVisiblePages) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }
  const pages = [];
  const half = Math.floor((maxVisiblePages - 2) / 2);
  const showLeftEllipsis = page > half + 2;
  const showRightEllipsis = page < totalPages - half - 1;
  pages.push(1);
  if (showLeftEllipsis) {
    pages.push(null);
  }
  const start = Math.max(2, page - half);
  const end = Math.min(totalPages - 1, page + half);
  for (let i = start; i <= end; i++) {
    pages.push(i);
  }
  if (showRightEllipsis) {
    pages.push(null);
  }
  pages.push(totalPages);
  return pages;
}
function Pagination({
  page,
  totalPages,
  onPageChange,
  showNavButtons = true,
  maxVisiblePages = 7,
  className,
  ariaLabel = "Pagination"
}) {
  if (totalPages <= 1) return null;
  const visiblePages = getVisiblePages(page, totalPages, maxVisiblePages);
  const baseButton = "inline-flex items-center justify-center min-w-[36px] h-9 px-3 text-sm rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed";
  const handlePrev = () => {
    if (page > 1) onPageChange(page - 1);
  };
  const handleNext = () => {
    if (page < totalPages) onPageChange(page + 1);
  };
  return /* @__PURE__ */ jsxs15("nav", { "aria-label": ariaLabel, className: cn("flex items-center justify-center gap-1", className), children: [
    showNavButtons && /* @__PURE__ */ jsx22(
      "button",
      {
        type: "button",
        onClick: handlePrev,
        disabled: page === 1,
        className: cn(baseButton, "text-text-primary hover:bg-background-elevated"),
        "aria-label": "Previous page",
        children: "Previous"
      }
    ),
    visiblePages.map((p, idx) => {
      if (p === null) {
        return /* @__PURE__ */ jsx22(
          "span",
          {
            className: "inline-flex items-center justify-center min-w-[36px] h-9 text-sm text-text-secondary",
            "aria-hidden": "true",
            children: "\u2026"
          },
          `ellipsis-${idx}`
        );
      }
      const isActive = p === page;
      return /* @__PURE__ */ jsx22(
        "button",
        {
          type: "button",
          onClick: () => onPageChange(p),
          "aria-current": isActive ? "page" : void 0,
          "aria-label": `Page ${p}`,
          className: cn(
            baseButton,
            isActive ? "bg-primary-500 text-white hover:bg-primary-600" : "text-text-primary hover:bg-background-elevated"
          ),
          children: p
        },
        p
      );
    }),
    showNavButtons && /* @__PURE__ */ jsx22(
      "button",
      {
        type: "button",
        onClick: handleNext,
        disabled: page === totalPages,
        className: cn(baseButton, "text-text-primary hover:bg-background-elevated"),
        "aria-label": "Next page",
        children: "Next"
      }
    )
  ] });
}

// src/components/web/VerifiedBadge.tsx
import { ShieldCheck } from "lucide-react";
import { jsx as jsx23 } from "react/jsx-runtime";
var VerifiedBadge = ({
  label = "Verified",
  size = "small",
  variant = "filled",
  className,
  title = "Email verified"
}) => {
  const iconSize = size === "small" ? 12 : 14;
  return /* @__PURE__ */ jsx23(
    Chip,
    {
      label,
      color: "success",
      size,
      variant,
      icon: /* @__PURE__ */ jsx23(ShieldCheck, { size: iconSize, "aria-hidden": "true" }),
      className,
      title,
      "aria-label": title
    }
  );
};
VerifiedBadge.displayName = "VerifiedBadge";

// src/web.ts
var theme = {
  colors,
  spacing,
  typography,
  shadows,
  elevation,
  borderRadius,
  borderWidth
};
var web_default = theme;
export {
  Alert,
  AuthCard,
  AuthLayout,
  Avatar,
  Button,
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
  Checkbox,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  IconButton,
  Input,
  InputLabel,
  MenuItem,
  Modal,
  PageContainer,
  Pagination,
  Select,
  Spinner,
  Tab,
  TabPanel,
  Tabs,
  TextField,
  Textarea,
  ThemeCards,
  ThemeProvider,
  ThemeSelector,
  ThemeSynchronizer,
  ThemeToggle,
  ThemeToggleCompact,
  ToggleButton,
  ToggleButtonGroup,
  VerifiedBadge,
  borderRadius,
  borderWidth,
  colors,
  containerVariants,
  web_default as default,
  defaultTheme,
  elevation,
  generateCSSVariables,
  getCSSVariablesString,
  getColor,
  getColorsForTheme,
  getCurrentColors,
  getCurrentMode,
  getCurrentTheme,
  getThemeColor,
  neutral,
  paddingVariants,
  sageGrey,
  setCurrentMode,
  setCurrentTheme,
  shadows,
  spacing,
  theme,
  themeNames,
  themePalettes,
  typography,
  useAppTheme,
  useAvailableThemes,
  useThemeColors
};
